import { render } from "./entity.vue?vue&type=template&id=40ac1b42&lang=html"
import script from "./entity.vue?vue&type=script&lang=js"
export * from "./entity.vue?vue&type=script&lang=js"

import "./entity.vue?vue&type=style&index=0&id=40ac1b42&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__